import React from "react";
import { Label } from "../Label";
import { Wrapper } from "../Wrapper";

import { DesignChapter } from "@learningblocks/storybook-components";

export function Empty(props) {
  const [showOptions, setShowOptions] = React.useState(false);

  const renderMobileLayer = () => {
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={() => setShowOptions(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setShowOptions(true);
          }
        }}
        className="mob_expStepEmpty"
        aria-label="Expand Step" // Provide a meaningful aria-label for accessibility
      ></div>
    );
  };

  const closeModal = () => setShowOptions(false);

  return (
    <>
      {showOptions && (
        <DesignChapter.StepOptionsModal
          onAddStep={props.onAddStep}
          list={props.options}
          isOpen={true}
          close={closeModal}
        />
      )}
      <Wrapper className="expStepEmpty" onDrop={props.onDrop}>
        <Label text={props.placeHolder} className="expStepEmpty--label" />
      </Wrapper>
      {renderMobileLayer()}
    </>
  );
}
